import { useMemo } from 'react';
import { resolveSmartLinkPlatformDomain } from 'fym-shared/src/smartlinks/domains';
import { useGetAccountQuery } from '../../../../redux/api/fymAPI';
import { removeHttpAndSlash } from '../../../smartLinks/utils/removeHttpRegex';
import { applyPlatformDomainToPrefix } from '../../../smartLinks/utils/platformDomainPrefix';

/**
 * The public address of a song's smartlink with no scheme ("mara.music24.link/halcyon"), built from
 * the account's host like the smartlink toolbar does. Null while the row has no smartlink.
 */
export function useSmartLinkAddress(accountId: number, slug: string | null): string | null {
  const { data } = useGetAccountQuery({ accountId }, { skip: slug === null });

  return useMemo(() => {
    if (slug === null || data === undefined) {
      return null;
    }
    const prefix = `${removeHttpAndSlash(data.account.shareUrl ?? 'slug.fym.fm')}/`;
    const domain = resolveSmartLinkPlatformDomain(undefined, data.account.platformDomain);
    return `${applyPlatformDomainToPrefix(prefix, domain)}${slug}`;
  }, [data, slug]);
}
